import { render, staticRenderFns } from "./newExpeditor.vue?vue&type=template&id=bd3e7192&scoped=true&"
import script from "./newExpeditor.vue?vue&type=script&lang=js&"
export * from "./newExpeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3e7192",
  null
  
)

export default component.exports